import React from 'react';
import classnames from 'classnames';
import { TThumbnail } from '../UploadingFileThumbnail.types';
import styles from '../UploadingFileThumbnail.scss';

export const Empty: TThumbnail = () => (
  <div className={classnames(styles.contentWrapper, styles.document)}>
    <div className={styles.content} />
  </div>
);
